import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressLaoDistrictSlice = createSlice({
    name: "getAddressLaoDistrict",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressLaoDistrictSlice_actions = getAddressLaoDistrictSlice.actions;
export var fetchData = _getAddressLaoDistrictSlice_actions.fetchData, fetchDataSuccess = _getAddressLaoDistrictSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressLaoDistrictSlice_actions.fetchDataFailure, resetState = _getAddressLaoDistrictSlice_actions.resetState;
export default getAddressLaoDistrictSlice.reducer;
